import type * as getMailboxSpecificRequestOptionsV2 from './getMailboxSpecificRequestOptionsV2';
import { LazyAction, LazyModule } from 'owa-bundling-light';

const lazyModule: LazyModule<typeof getMailboxSpecificRequestOptionsV2> = new LazyModule<
    typeof getMailboxSpecificRequestOptionsV2
>(
    () =>
        import(
            /* webpackChunkName: "GetMailboxSpecificRequestOptionsV2" */ './getMailboxSpecificRequestOptionsV2'
        ),
    { name: 'GetMailboxSpecificRequestOptionsV2' }
);

export const lazyGetMailboxSpecificRequestOptionsV2: LazyAction<
    typeof getMailboxSpecificRequestOptionsV2.default,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.default);

export const lazyGetMailboxSpecificRequestOptionsFromMailboxInfo: LazyAction<
    typeof getMailboxSpecificRequestOptionsV2.getMailboxSpecificRequestOptionsFromMailboxInfo,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getMailboxSpecificRequestOptionsFromMailboxInfo);
